import { AbstractProjectModel } from "@app/catalog-common";

export class ProjectNotFoundMessage {
    
    public project: AbstractProjectModel;
    
    constructor(project: AbstractProjectModel)
    {
        this.project = project;
    }
}